export const presets = {
    categories: [
        'Anklets',
        'Baby Bracelets',
        'Baby Rings',
        'Bracelets',
        'Bridal Set',
        'Chains',
        'Charm Necklace Set',
        'Charms',
        'Choker',
        'Earrings',
        'Engagement Rings',
        "Men's Bracelets",
        "Men's Rings",
        "Men's Watches",
        'Necklaces',
        'Pendants',
        'Piercings',
        'Rings',
        'Services',
        'Wedding Bands',
        "Women's Watches"
    ],

    metals: {
        '18K': '18K',
        '14K': '14K',
        '19K': '19K',
        '10K': '10K',
        Silver: 'SIL',
        Platinum: 'PLAT',
        Tungsten: 'TUN',
        'Stainless Steel': 'SS',
        '22K': '22K'
    },

    gemstones: {
        diamond: 'DIA',
        lab_diamond: 'LDI',
        cubic_zirconia: 'CZ',
        sapphire: 'SAP',
        ruby: 'RUB',
        emerald: 'EMR',
        aquamarine: 'AQU',
        citrine: 'CIT',
        amethyst: 'AMT',
        onyx: 'ONX',
        smoked_crystal: 'SMC',
        pink_quartz: 'PQZ',
        crystal: 'CRY',
        moissanite: 'MOS',
        garnet: 'GAR',
        quartz: 'QTZ',
        smoked_quartz: 'SQZ',
        tsavorite: 'TSA',
        black_diamond: 'BLD',
        blue_diamond: 'BUD',
        champagne_diamond: 'CDI',
        green_gold: 'GG',
        green_amethyst: 'GAM',
        morganite: 'MOR',
        mother_of_pearl: 'MOP',
        peridot: 'PER',
        tanzanite: 'TAN',
        topaz: 'TOP',
        watermelon_tourmaline: 'WTM',
        pink_tourmaline: 'PTM',
        green_tourmaline: 'GTM',
        black_pearl: 'BPL',
        pearl: 'PRL',
        slice_of_turquoise: 'SLT',
        turquoise: 'TUR',
        tigers_eye: 'TIG',
        cats_eye: 'CAT',
        rutilated_quartz: 'RQZ',
        jade: 'JAD',
        lapis: 'LAP',
        agate: 'AGA',
        rustic_ruby: 'RR',
        malachite: 'MAL',
        yellow_sapphire: 'YSA',
        pink_sapphire: 'PSA'
    },

    vendors: [
        'Soul Mate',
        'MyOro',
        'D.K Italy',
        'B&D',
        'Mr.Bracelet',
        'Lamar',
        'Delson Jewelry',
        'Nouriely',
        'Empire',
        'Emperor',
        'Nova',
        'Martins',
        'Kalaja Jewelry',
        'JDM',
        'R&N International',
        'Seiko',
        'Bulova',
        'Unknown'
    ],

    colors: ['Yellow', 'White', 'Rose', 'Black']
}

export default {}
